import React from 'react'
// containers
import PlansContainer from 'containers/Plan/Register'

const PlansPage: React.FC = () => <PlansContainer />

export default PlansPage
